import React, { FC } from 'react'
import { environment } from '@mortgage-pos/ui/env'
import { iconMap } from '@mortgage-pos/ui/utils/customizationHelpers'

interface Props {
  showRateInfo?: boolean
}

export const CompareFooter: FC<Props> = ({ showRateInfo = false }) => {
  return (
    <div className="compare-page__footer">
      <div className="compare-page__social">
        <h5 className="compare-page__social-title">Follow us:</h5>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/SageMortgage"
        >
          <img
            className="compare-page__social-icon"
            src={iconMap('facebook')}
            alt="Facebook"
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.instagram.com/sagemortgage/"
        >
          <img
            className="compare-page__social-icon"
            src={iconMap('instagram')}
            alt="Instagram"
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/company/sagemortgage/"
        >
          <img
            className="compare-page__social-icon"
            src={iconMap('linkedIn')}
            alt="LinkedIn"
          />
        </a>
      </div>
      <img
        className={`compare-page__footer-img --${environment.productName}`}
        src={iconMap('footer')}
        alt="Footer"
      />
      {showRateInfo ? (
        <div className="rate-selections__info">
          <p className="rate-selections__info-block">
            <span className="rate-selections__info-block-heading">
              Annual Percentage Rate (APR):
            </span>
            Is the cost to borrow money expressed as a yearly percentage, it
            includes the interest rate plus estimated closing costs and other
            fees.
          </p>

          <p className="rate-selections__info-block">
            <span className="rate-selections__info-block-heading">
              Taxes and Insurance Excluded from Loan Terms:
            </span>
            The loan terms (APR and Payment examples) shown above do not include
            amounts for taxes or insurance premiums. Your monthly payment amount
            will be greater if taxes and insurance premiums are included. The
            estimated costs and fees above do not constitute and are not a
            substitute for a loan estimate, which includes an estimate of
            closing costs you will receive once you apply for a loan. The
            amounts provided above, are estimations based on the criteria you
            submitted and the state selected. The actual fees, costs, and
            monthly principal and interest payments on your specific loan
            transaction may vary, and may include taxes, insurance, or other
            additional fees and costs. These mortgage rates are based upon a
            variety of assumptions and conditions, per the information you
            submitted upon requesting a quote. Your loan's interest rate will
            depend upon the specific characteristics of your loan transaction,
            the verification of the information you provide, and your credit
            history up to the time of closing. This is NOT a mortgage loan
            approval or commitment to lend.
          </p>
        </div>
      ) : null}
    </div>
  )
}
